import cookie from "@src/lib/cookie";
import {FormatStringNew,getHostName } from "@roots/pLibrary/javascriptTool.js";
const {noEmpty} = FormatStringNew
const isLogining = () => {
  return noEmpty(cookie("COOKIE_USER_X_TOKEN"))
};
const toLoginingRedirectUri = (url,query ="") => {
    const _url1 = url || window.location.href
    window.location.href = `${getHostName()}/auth/#/connect/login?redirectUri=${encodeURIComponent(_url1)}${query}`;
};
export default{
  isLogining,
  toLoginingRedirectUri
}